import type { ComponentTheme } from '../types/component-theme';

import { truncatedChipLabelStyles } from '../shared-styles';
import { SubstepNavigationChipStates } from './constants/substep-navigation-chip-state';

const rootStyles = 'bg-(image:--accent-gradient) border-transparent text-(--pure-white)';

export default {
    slots: {
        root: '',
        dot:
            'flex items-center justify-center size-4.5 rounded-full shrink-0 bg-(--slate-alpha-12) text-[0.6rem] ' +
            'font-extrabold',
        label: truncatedChipLabelStyles
    },
    variants: {
        state: {
            [SubstepNavigationChipStates.Available]: {},
            [SubstepNavigationChipStates.Active]: {
                root: `${rootStyles} shadow-(--workflow-substep-current-shadow) hover:opacity-100`,
                dot: 'bg-(--white-alpha-25)'
            },
            [SubstepNavigationChipStates.Done]: {
                root: `${rootStyles} opacity-[0.72] shadow-(--workflow-substep-completed-shadow)`,
                dot: 'bg-(--white-alpha-25)'
            },
            [SubstepNavigationChipStates.Locked]: {
                root: 'opacity-35 cursor-not-allowed'
            }
        }
    }
} satisfies ComponentTheme;
